<template>
  <div v-if="!showMeTheBanner && show" class="container-fluid alert fade show text-uppercase text-center flex-row center-vertically justify-content-center m-0 bg-live" role="alert">
    <span class="pt-0 pb-1 pr-1">
      <img :src="src" alt="" class="rolling_camera_banner_img pr-1">
    </span>
    <span class="pt-2 pl-1 camera">
      <a :href="link" class="rolling_camera_banner_text nounderline">{{__('auction-live')}}</a>
    </span>
  </div>
</template>

<script>
export default {
  name: "live-banner",
  props: ['src', 'show', 'link'],
  data: function() {
    return {
      showMeTheBanner: '',
    }
  },
  methods: {
  hideBanner: () => {
      sessionStorage.setItem("showBanner", "false");
    },
    __: function (key) {
        return window.AG.generic[key];
    },
  },
  computed: {
  },
  mounted() {
    if (sessionStorage.showBanner) {
      this.showMeTheBanner = sessionStorage.showBanner;
    }
  },

}
</script>
